import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
    ebooks: [],
    ebooksDetail: {},
    ebooksType: [],
    ebooksClass: {},
    ebooksFilter: {},
    allClasses: [],
    bookRelation: [],
    searchResult: [],
    filters: {},
    typeFilters: {},
    ebookFAQ: [],
    //ebooksGroup:[],
    exerciseDetail: {},
    question_exercise: [],
    question_exercise_info: {},
    open_math: {},
    math_value: null,
    validate_question: {},
    question_activity: {},
    check_answer: false,
    question_valid_data: [],
    paramSearchRelateMedia: { bookId: 0, pageNo: 0, typeId: 0, pageIndex: 0, pageSize: 6 },
    getTraningId: 0,
    questionBookWorking: {},
    mediaBookViewing: null,
    lessonBookViewing: null,
    dataBookDeactive: {},
    idBookDeactiveDone: 0
};

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};